import { saveAs } from "file-saver";

let authUserToken;

export const setToken = (token) => {
  authUserToken = token;
};

const authorize = (request) => {
  if (authUserToken) {
    return {
      ...request,
      headers: {
        ...request.headers,
        authorization: `bearer ${authUserToken}`,
      },
    };
  }
  return request;
};

const getJSONContent = async (response) => {
  const contentType = response.headers.get("content-type");
  if (contentType && contentType.indexOf("application/json") !== -1) {
    const data = await response.json();
    return data;
  }
  return null;
};

const getFileNameFromDisposition = (response) => {
  const contentType = response.headers.get("content-disposition");
  if (contentType && contentType.indexOf("filename*=UTF-8''") !== -1) {
    const fileName = contentType.split("filename*=UTF-8''")[1];
    return fileName;
  }
  return undefined;
}

export const fetchRequest = async (requestConfig, withAuthorization = true) => {
  if (withAuthorization && !authUserToken) {
    throw new Error("NOT_AUTHORIZED");
  }
  const request = authorize(requestConfig);

  const response = await fetch(request.url, {
    method: request.method,
    headers: request.headers,
    body: request.body,
  });

  if (!response.ok) {
    if ([401, 403].indexOf(response.status) !== -1) {
      throw new Error("ACCESS_DENIED");
    }
    const specificError = await getJSONContent(response);
    if (specificError && specificError.message) {
      throw new Error(specificError.message);
    }
    throw new Error(`Request ${requestConfig.url} failed!`);
  }
  return getJSONContent(response);
};

export const fetchFileRequest = async (
  requestConfig,
  withAuthorization = true
) => {
  if (withAuthorization && !authUserToken) {
    throw new Error("NOT_AUTHORIZED");
  }
  const request = authorize(requestConfig);

  const response = await fetch(request.url, {
    method: request.method,
    headers: request.headers,
    body: request.body,
  });

  if (!response.ok) {
    if ([401, 403].indexOf(response.status) !== -1) {
      throw new Error("ACCESS_DENIED");
    }
    return undefined;
  }
  const blob = await response.blob();

  saveAs(blob, getFileNameFromDisposition(response));
};

const httpService = {
  fetchRequest,
};

export default httpService;
